<template>
  <b-nav tabs>
    <b-nav-item v-bind:active="section == 'ledgers'"
                v-on:click="set_section('ledgers')">
      Ledgers
    </b-nav-item>

    <b-nav-item v-bind:active="section == 'fees'"
                v-on:click="set_section('fees')">
      Fees
    </b-nav-item>

    <b-nav-item v-bind:active="section == 'txs'"
                v-on:click="set_section('txs')">
      Transactions
    </b-nav-item>

    <b-nav-item v-bind:active="section == 'tx_types'"
                v-on:click="set_section('tx_types')">
      TX Types
    </b-nav-item>

    <b-nav-item v-bind:active="section == 'accounts'"
                v-on:click="set_section('accounts')">
      Accounts
    </b-nav-item>
  </b-nav>
</template>

<script>
export default {
  name: 'ReportSectionsHeader',

  computed : {
    section : function() {
      return this.$store.state.report.section;
    },

    selected_report : function(){
      return this.$store.state.report.selected;
    },

    have_period : function(){
      return !!this.selected_report.period;
    }
  },

  methods : {
    set_section : function(section){
      let period    = this.have_period ?
                      this.$store.helpers.report_selected_period_name():
                      this.$store.helpers.report_period_name();
      let timestamp = this.$store.state.report.selected.timestamp;

      if(timestamp)
        this.$router.push("/report/" + period +
                          "/" + timestamp     +
                          "/" + section);

      else if(period)
        this.$router.push("/reports/" + period +
                          "/" + section);

      else
        this.$router.push("/reports/" + section);
    },
  }
}
</script>

<style scoped>
</style>
